import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';
import store from './store/configureStore';

function renderApp() {
  const App = require('./App').default;

  ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
  );
}

if(module.hot) {
  module.hot.accept('./App', () => {
      setTimeout(renderApp);
  });
}

renderApp();

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js